// extracted by mini-css-extract-plugin
export default {"emoji":"styles_emoji__MXPKU","emojiOpen":"styles_emojiOpen__n5m1E"};